import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable } from 'rxjs';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { StateDto } from '../../models/location/state-dto';
import {
  CityDto,
  CityWithAttributeDto,
  RemoveCityAttributeRequestDto,
  UpdateCityAttributeRequestDto
} from '../../models/location/city-dto';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/locales`;

  constructor(private readonly http: HttpClient) {}

  findAllStates(): Observable<StateDto[]> {
    return this.http.get<StateDto[]>(`${this.endpoint}/states`);
  }

  findCitiesByState(stateId: number): Observable<CityDto[]> {
    return this.http.get<CityDto[]>(`${this.endpoint}/cities/state/${stateId}`);
  }

  findCityAttributes(productLineId: number, stateId: number, cityId: number, distributorId: number): Observable<CityWithAttributeDto[]> {
    const params = new URLSearchParams();
    if (productLineId) params.append('productLineId', productLineId.toString());
    if (stateId) params.append('stateId', stateId.toString());
    if (cityId) params.append('cityId', cityId.toString());
    if (distributorId) params.append('distributorId', distributorId.toString());
    return this.http.get<CityWithAttributeDto[]>(`${this.endpoint}/city-attributes?${params.toString()}`);
  }

  updateCityAttributes(data: UpdateCityAttributeRequestDto[]): Observable<void> {
    return this.http.put<void>(`${this.endpoint}/city-attributes`, data);
  }

  removeCityAttributes(data: RemoveCityAttributeRequestDto[]): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/city-attributes`, { body: data });
  }
}
